<template>
  <div
    class="flex flex-wrap align-center"
    data-qa="planning-actions-snackbar">
    <sBadge
      color="var(--white-color)"
      :content="elements.length"
      data-qa="planning-action-toolbar-badge"
      offset-x="11"
      offset-y="11"
      overlap
      text-color="var(--black-color)">
      <sButton
        color="var(--white-color)"
        small
        type="border"
        @click="createTenders">
        {{ $t('Tenders.CreateTender') }}
      </sButton>
    </sBadge>
    <InDevelopmentInfo condition>
      <template #activator>
        <sButton
          class="ml-2"
          color="var(--white-color)"
          small
          type="text">
          {{ $t('Tenders.AddToTender') }}
        </sButton>
      </template>
    </InDevelopmentInfo>
    <sPopover
      v-if="elements.length == 1"
      :open-delay="300"
      placement="top-end"
      trigger="click">
      <template #reference="{show}">
        <sButton
          slot="reference"
          color="var(--white-color)"
          :data-qa="`btn-menu-${show ? 'active' : ''}`"
          icon="menu"
          icon-size="20px"
          small
          type="text"/>
      </template>
      <div>
        <InDevelopmentInfo
          :condition="CHAT_IN_DEVELOPMENT"
          prevent>
          <template #activator>
            <CommentDialog
              dialogue-type="ROW"
              :element.sync="first"
              :join-chat="options.joinChat"
              list_item
              :user="options.user"
              @callback="options.callback"/>
          </template>
        </InDevelopmentInfo>
      </div>
    </sPopover>
  </div>
</template>
<script>
import CommentDialog from 'components/purchasing/purch item/CommentDialog.vue'
import InDevelopmentInfo from 'components/common/elements/InDevelopmentInfo.vue'

export default {
  name: 'planningActionsToolbar',
  data() {
    return {
      CHAT_IN_DEVELOPMENT: true,
    }
  },
  props: {
    options: Object
  },
  computed: {
    elements() {
      return this.options.elements || []
    },
    first() {
      return this.elements[0] || {}
    },
  },
  methods: {
    createTenders() {
      this.$store.commit('editNewTender',  {
        lots: this.elements
      })
      this.$store.commit('setNewTenderInfo', {mode: 'plan', step: 1 })
      this.$router.push({name: 'newTender' , params: {org: this.$route.params.org}})
    },
  },
  components: {
    CommentDialog,
    InDevelopmentInfo
  }
}
</script>
